import { FC } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../shared/components/Icon";
import { PATHS } from "../../../paths";
import { BlogPost } from "../posts";

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: FC<BlogCardProps> = ({ post }) => (
  <Link className="it-post" to={`${PATHS.blog}/${post.slug}`}>
    <span className="it-post-band" />
    <div className="it-post-body">
      <span className="it-tag">{post.tag}</span>
      <h4>{post.title}</h4>
      <p>{post.desc}</p>
      <span className="it-more">
        Devamını Oku <Icon name="arrow" />
      </span>
    </div>
  </Link>
);

export default BlogCard;
